import 'scss/navigation_menu.scss';

import PropTypes from 'prop-types';
import * as R from 'ramda';

import React from 'react';
import {Nav, NavItem, NavDropdown, MenuItem} from 'react-bootstrap';

import {PendingApproval} from 'js/approval_queues/constants';
import {updateHash, getHashObject} from 'js/common/url_helper';

const NavigationMenu = props => {
    const {
        isAdmin,
        isSalesUser,
        activeKey,
        campaign,
        urls: {
            campaignAnalyticsUrl,
            campaignApprovalQueuesUrl,
            campaignExecutionUrl,
            launch: {
                campaignConfigUrl,
                crmFiltersUrl,
                flightPlanUrl,
                leadHopperUrl,
                verifyLaunchReceiptUrl
            },
            requestToLaunch: {
                brandSetupUrl,
                creatorQualityUrl,
                creatorSampleUrl,
                launchDetailsUrl,
                launchReviewUrl,
                verifyRequestToLaunchReceiptUrl
            }
        }
    } = props;

    if (!isAdmin || isSalesUser) {
        return <div />;
    }

    return (
        <div id="execution-menu">
            <Nav bsStyle="tabs" activeKey={activeKey}>
                <NavDropdown
                    eventKey="request-to-launch"
                    title="Request To Launch"
                    id="request-to-launch-dropdown"
                >
                    <MenuItem
                        eventKey="request-to-launch.verify-receipt"
                        href={verifyRequestToLaunchReceiptUrl.replace('__ID__', campaign.id)}
                    >
                        <span>Campaign Details</span>
                    </MenuItem>
                    {/* <MenuItem eventKey="request-to-launch.brand-setup" href={brandSetupUrl.replace('__ID__', campaign.id)}>
                        <span>Brand Setup</span>
                    </MenuItem> */}
                    <MenuItem
                        eventKey="request-to-launch.launch-details"
                        href={launchDetailsUrl.replace('__ID__', campaign.id)}
                    >
                        <span>Launch Details</span>
                    </MenuItem>
                    <MenuItem
                        eventKey="request-to-launch.creator-quality"
                        href={creatorQualityUrl.replace('__ID__', campaign.id)}
                    >
                        <span>Creator Quality</span>
                    </MenuItem>
                    <MenuItem
                        eventKey="request-to-launch.review-and-accept"
                        href={launchReviewUrl.replace('__ID__', campaign.id)}
                    >
                        <span>Review &amp; Accept</span>
                    </MenuItem>
                </NavDropdown>
                <NavDropdown eventKey="launch" title="Launch" id="launch-dropdown">
                    <MenuItem
                        eventKey="launch.verify-receipt"
                        href={verifyLaunchReceiptUrl.replace('__ID__', campaign.id)}
                    >
                        <span>Request to Launch Receipt</span>
                    </MenuItem>
                    <MenuItem
                        eventKey="launch.campaign-configuration"
                        href={campaignConfigUrl.replace('__ID__', campaign.id)}
                    >
                        <span>Campaign Configuration</span>
                    </MenuItem>
                    <MenuItem
                        eventKey="launch.flight-plan"
                        href={flightPlanUrl.replace('__ID__', campaign.id)}
                    >
                        <span>Flight Plan</span>
                    </MenuItem>
                    <MenuItem
                        eventKey="launch.crm-search"
                        href={crmFiltersUrl.replace('__ID__', campaign.id)}
                    >
                        <span>CRM Search</span>
                    </MenuItem>
                    <MenuItem
                        eventKey="launch.lead-hopper"
                        href={leadHopperUrl.replace('__ID__', campaign.id)}
                    >
                        <span>Lead Hopper</span>
                    </MenuItem>
                </NavDropdown>
                <NavDropdown
                    eventKey="approval-queues"
                    title="Approval Queues"
                    id="approval-dropdown"
                >
                    <MenuItem
                        eventKey="approval-queues.pending-creators"
                        href={`${campaignApprovalQueuesUrl.replace(
                            '__ID__',
                            campaign.id
                        )}#${updateHash({sort: PendingApproval.Creators})}`}
                        className={
                            R.equals(
                                PendingApproval.Creators,
                                R.propOr(null, 'sort', getHashObject())
                            )
                                ? 'active'
                                : null
                        }
                    >
                        <span>Sorted By Pending Creators</span>
                    </MenuItem>
                    <MenuItem
                        eventKey="approval-queues.pending-content"
                        href={`${campaignApprovalQueuesUrl.replace(
                            '__ID__',
                            campaign.id
                        )}#${updateHash({sort: PendingApproval.Content})}`}
                        className={
                            R.equals(
                                PendingApproval.Content,
                                R.propOr(null, 'sort', getHashObject())
                            )
                                ? 'active'
                                : null
                        }
                    >
                        <span>Sorted By Pending Content</span>
                    </MenuItem>
                </NavDropdown>
                <NavItem
                    eventKey="execution"
                    title="Execution"
                    id="execution-link"
                    href={campaignExecutionUrl.replace('__ID__', campaign.id)}
                >
                    <span>Execution</span>
                </NavItem>
                <NavItem
                    eventKey="analytics"
                    title="Analytics"
                    id="analytics-link"
                    href={campaignAnalyticsUrl.replace('__ID__', campaign.id)}
                >
                    <span>Analytics</span>
                </NavItem>
            </Nav>
        </div>
    );
};

NavigationMenu.propTypes = {
    isAdmin: PropTypes.bool,
    isSalesUser: PropTypes.bool,
    activeKey: PropTypes.string.isRequired,
    campaign: PropTypes.shape({
        id: PropTypes.number.isRequired
    }),
    urls: PropTypes.shape({
        navigationMenu: PropTypes.shape({
            campaignAnalyticsUrl: PropTypes.string.isRequired,
            campaignApprovalQueuesUrl: PropTypes.string.isRequired,
            campaignExecutionUrl: PropTypes.string.isRequired,
            launch: PropTypes.shape({
                campaignConfigUrl: PropTypes.string.isRequired,
                crmFiltersUrl: PropTypes.string.isRequired,
                flightPlanUrl: PropTypes.string.isRequired,
                leadHopperUrl: PropTypes.string.isRequired,
                verifyLaunchReceiptUrl: PropTypes.string.isRequired
            }),
            requestToLaunch: PropTypes.shape({
                brandSetupUrl: PropTypes.string.isRequired,
                creatorQualityUrl: PropTypes.string.isRequired,
                creatorSampleUrl: PropTypes.string.isRequired,
                launchDetailsUrl: PropTypes.string.isRequired,
                launchReviewUrl: PropTypes.string.isRequired,
                verifyRequestToLaunchReceiptUrl: PropTypes.string.isRequired
            })
        })
    })
};

NavigationMenu.defaultProps = {
    isAdmin: false,
    isSalesUser: false
};

export default NavigationMenu;



// WEBPACK FOOTER //
// ./components/navigation_menu.js